export default __webpack_public_path__ + "static/media/Harkirat_Singh_Resume.99f0a988.pdf";